export const deviceUpdate = data => {
  return {
    enabled: data.enabled
  };
};
